import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGiroCard"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM9 9H6V10.5H9V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiroCard;
